import { Navigate } from "react-router-dom";
import { Balance } from "../context/Context";
import { BsCheckLg } from "react-icons/bs";
import { Card, Page, Text } from "@shopify/polaris";

export default function Success() {
  const { amount } = Balance();

  if (!amount) {
    return <Navigate to={"/not-found"} />;
  }

  return (
    <Page>
      <Card>
        <div className="w-full px-4 py-10">
          <div className="max-w-sm mx-auto">
            <div className="grid w-full gap-4 text-center items-center">
              <h1 className="text-2xl font-medium text-green-500">
                <Text variant="headingLg">Payment confirmed</Text>
              </h1>
              <div className="items-center justify-center p-[6px] mx-auto bg-green-100 border-[3px] border-green-500 rounded-full bg-opacity-70 w-fit">
                <BsCheckLg className="w-8 h-8 text-green-500" />
              </div>
              <div className="flex justify-between col-span-2 px-2 py-1 my-2 rounded-md bg-opacity-20 bg-cbyellow">
                <h1 className="col-span-1 font-light text-start">Total paid</h1>
                <h1 className="col-span-1 font-bold text-end">
                  {/* display two decimal places
                   * taken from:
                   * https://stackoverflow.com/questions/6134039/format-number-to-always-show-2-decimal-places
                   */}
                  £{(Math.round(amount * 100) / 100).toFixed(2)}
                </h1>
              </div>
            </div>
            <div className="mx-auto">
              <Text> Refresh page to return </Text>
            </div>
          </div>
        </div>
      </Card>
    </Page>
  );
}
